import {
  fonts,
  fontSizes,
  fontWeights,
  lineHeights,
  lineHeightsShorter,
  lineHeightsTaller,
  tvgColorPalette as colors,
  space,
  breakpoints,
  radii,
  buttons,
  iconButtons,
  elevations,
  iconSizes
} from "./common";

import { tvgColorTokens as colorTokens } from "./tokens";

import { Theme, HeadingSizes } from "../types";

const name = "Desktop";

const headingSizes: HeadingSizes = {
  h1: { fontSize: fontSizes["3xl"], lineHeight: lineHeights["3xl"] },
  h2: { fontSize: fontSizes.l, lineHeight: lineHeights.l },
  h3: { fontSize: fontSizes.m, lineHeight: lineHeights.m }
};

export default {
  name,
  breakpoints,
  colors,
  colorTokens,
  space,
  fonts,
  fontSizes,
  lineHeights,
  lineHeightsShorter,
  lineHeightsTaller,
  fontWeights,
  headingSizes,
  radii,
  buttons,
  iconButtons,
  elevations,
  iconSizes
} as Theme;
